import styled, { keyframes } from 'styled-components';
import { MIN_TABLET_BREAKPOINT, SELECTORS } from '../../../../constants/constants';

interface IProgressBarProps {
    previousWidth: number;
    newWidth: number;
}

interface IBadgeProps {
    highlightedBadge: boolean;
    previousBadge? : boolean;
}

export const LoadingAnimation = ({ previousWidth, newWidth }: IProgressBarProps) => keyframes`
  from {
    width : ${previousWidth + '%'}
  }
  to {
     width : ${newWidth + '%'}
  }
`;

export const ProgressBarDesktopContainer = styled.div`
    @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            display:  none;  
        }
    } 
`;

export const BadgesContainer = styled.div`
    ${SELECTORS} & {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-bottom: 20px;
    }
`;




export const BadgeItem = styled.div`
    animation-name:  ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? animateBadgeIn : animateBadgeOut};
    ${SELECTORS} & {
      cursor: pointer;
      margin: 15px auto 20px auto;
      animation-duration: 1.5s;
      //Makes the last keyframe style stick to the animation
      animation-fill-mode:forwards;
    }
`;

export const BadgeTopButton = styled.div`
    animation-name:  ${({ highlightedBadge }: IBadgeProps) => highlightedBadge ? animateBadgeTitleIn : animateBadgeTitleOut};
    ${SELECTORS} & {
      text-align: center;
      margin: 0 -10px;
      color: white;
      font-size: 14px;
      border: 1px solid white;
      border-radius: 12px;
      cursor: pointer;
      font-family: 'Ubuntu', sans-serif;
      font-weight: 400;
      animation-duration: 1.5s;
      //Makes the last keyframe style stick to the animation
      animation-fill-mode:forwards;
    }
   
`;
export const BadgeBottomText = styled.p`
    animation-name:  ${({ highlightedBadge, previousBadge }: IBadgeProps) => highlightedBadge ? animateBadgeIn : animateBadgeOut};
    ${SELECTORS} & {
      cursor: pointer;
      text-align: center;
      color: white;
      margin: 10px 0;
      font-family: 'Ubuntu', sans-serif;
      font-weight: bold;
      font-size: 20px;
      line-height: 20px;
      animation-duration: 1.5s;
      //Makes the last keyframe style stick to the animation
      animation-fill-mode:forwards;
    }
   
`;


export const BadgeItemContainer = styled.div`
    ${SELECTORS} & {
      margin: auto;
    }
    &:hover   {
        ${BadgeItem} {
          opacity: 1  !important;
        }
        ${BadgeTopButton} {
          opacity: 1  !important;
          background : #13A121  !important;
          border-color : #13A121 !important;
        }
        ${BadgeBottomText} {
          opacity: 1  !important;
        }
        
    }
`;

export const ProgressBarContainer = styled.div`
   height: 30px;
   width: 100%;
   border-radius: 12px;
   border: 1px solid rgba(255, 255, 255, .3);  
`;


export const ProgressBarArrowContainer = styled.div`
    ${SELECTORS} & {
     margin: 0 auto;
        svg{
         display: block;
          margin: 0 auto;
        }
    }
`;

export const ArrowDivContainer = styled.div`
    ${SELECTORS} & {
      position: relative;
      top: -24px;
      z-index: 0;
      display: flex;
      flex-wrap: wrap;
      margin: 1px auto;
      width: 80%;
    }
`;

export const ProgressBarItem = styled.div`
    border-radius: 12px;
    height: 20px;
    margin: 4px auto 5px 2px;
    position: relative;
    width: ${({ newWidth } : IProgressBarProps) => newWidth+'%'};
    z-index: 1;
    animation:  ${({previousWidth, newWidth } : IProgressBarProps) => LoadingAnimation({ previousWidth, newWidth })} 1s linear;
    background-image: linear-gradient(269.47deg, #47E975 3.67%, #0077EE 99.54%);;
`;

export const GiftBadgeContainer = styled.div`
    ${SELECTORS} & {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
`;

export const GiftBadgeItem = styled.div`
    ${SELECTORS} & {
      margin: 20px auto;
      width: 25%;
      svg{
        height: 50px;
        width: auto;
      }
    }
    
    .firstGift{
     margin-right: -7px;
    }
    .giftIcon{
     margin-right: -7px;
    }
`;

export const GiftIcon = styled.div`
    ${SELECTORS} & {
        width: fit-content;
        margin: auto;
    }
`;

export const GiftDescription = styled.div`
    ${SELECTORS} & {
      color: white;
      text-align: center;
      font-size: 16px;
      font-family: 'Ubuntu', sans-serif;
    }
    b{
       color: white;
      text-align: center;
      font-family: 'Ubuntu', sans-serif;
          font-weight: bold;
      font-size: 16px;
    }
`;


const animateBadgeIn = keyframes`
    0% {opacity:0.3;}
    100% {opacity:1;}
`

const animateBadgeOut = keyframes`
    0% {opacity:1;}
    100% {opacity:0.3;}
`

const animateBadgeTitleIn = keyframes`
    0% {
        opacity:0.3;
        background : unset;
        border-color:  white
    }
    100% {
        opacity:1;
        background : #13A121;
        border-color:  #13A121
    }
`;

const animateBadgeTitleOut = keyframes`
    0% {
      opacity:1;
    }
   100% {
        opacity:0.3;
        background : unset;
        border-color:  white;
    }
 `;